// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + chunkId + "." + {360: "1532b12e96",470: "a7cdf36db4",}[chunkId] + ".css"
}